import React from "react";
import "./loader.scss";
import LoaderImg from "../../assets/img/loader.gif";

class Loader extends React.Component {
  constructor() {
    super();
    this.state = {};
  }

  render() {
    const active = this.props.active;
    return (
      <div
        className={active ? "loader-overlay" : "loader-overlay-none"}
        style={{ display: active ? "" : "none" }}
      >
        <img className="loader" src={LoaderImg} alt="Loader"></img>
      </div>
    );
  }
}

export default Loader;
